import { ModalName, ModalsMapType } from 'store/modals/types';

import CancellationReasonModal from 'components/Modals/CancellationReasonModal';
import ConfirmCancellationModalContainer from 'components/Modals/ConfirmCancellationModalContainer';
import DiscountOfferModal from 'components/Modals/DiscountOfferModal';
import ErrorModal from 'components/Modals/ErrorModal';
import FeedbackFormModal from 'components/Modals/FeedbackFormContainer/FeedbackFormModal';
import PauseSubscriptionModal from 'components/Modals/PauseSubscriptionModal';
import PlanSuggestionOfferModal from 'components/Modals/PlanSuggestionOfferModal';
import ReasonAbandonModal from 'components/Modals/ReasonAbandonModal';
import ReminderOfferModal from 'components/Modals/ReminderOfferModal';
import ReminderSuccessModal from 'components/Modals/ReminderSuccessModal';
import RestoreSubscriptionModal from 'components/Modals/RestoreSubscriptionModal';
import UniversalModal from 'components/Modals/UniversalModal';
import VideoInstructionModal from 'components/Modals/VideoInstructionModal';
import WaitingModal from 'components/Modals/WaitingModal';

import CancellationFeeConfirmModal from '../components/Modals/CancellationFeeConfirmModal';
import CancellationFeePaymentModal from '../components/Modals/CancellationFeePaymentModal';
import ErrorModalWithPayment from '../components/Modals/ErrorModalWithPayment';

export const MODAL_LIST: ModalsMapType = {
    [ModalName.feedbackForm]: FeedbackFormModal,
    [ModalName.confirmCancelWorkout]: ConfirmCancellationModalContainer,
    [ModalName.workoutReasonAbandon]: ReasonAbandonModal,
    [ModalName.universalModal]: UniversalModal,
    [ModalName.videoInstructionModal]: VideoInstructionModal,
    [ModalName.cancellationReasonModal]: CancellationReasonModal,
    [ModalName.discountOfferModal]: DiscountOfferModal,
    [ModalName.pauseSubscriptionModal]: PauseSubscriptionModal,
    [ModalName.waitingModal]: WaitingModal,
    [ModalName.planSuggestion]: PlanSuggestionOfferModal,
    [ModalName.reminderOfferModal]: ReminderOfferModal,
    [ModalName.restoreSubscriptionModal]: RestoreSubscriptionModal,
    [ModalName.reminderSuccessModal]: ReminderSuccessModal,
    [ModalName.errorModal]: ErrorModal,
    [ModalName.errorModalWithPayment]: ErrorModalWithPayment,
    [ModalName.feeAlert]: CancellationFeeConfirmModal,
    [ModalName.feePayment]: CancellationFeePaymentModal,
};
